<template>
  <div id="app" class="py-20">

    <nav ref="nav" class="mb-12">
      <div class="container">
        <h1 class="font-300 text-center mb-8">選擇想查詢的家電</h1>
      </div>
      <div
        class="overflow-x-auto whitespace-no-wrap text-center bg-edf0f5 py-10"
        style="touch-action: pan-x; scroll-behavior: smooth; color:#bfc5cf">
        <router-link
          v-for="(type, index) of ApplianceTypes"
          :key="index"
          :to="`/${type.id}`"
          class="inline-flex flex-col items-center hover:no-underline mx-4"
          active-class="text-black">
          <div :class="`icon-surco-device-${type.id}`" style="font-size:4rem"></div>
          <div class="whitespace-no-wrap">{{ type.name }}</div>
        </router-link>
      </div>
    </nav>

    <router-view :brands="brands" :isLoading="isLoading">
      <template v-if="isLoading" slot="spinner">
        <hollow-dots-spinner
          :animation-duration="1000"
          :dot-size="15"
          :dots-num="3"
          color="#000"
          class="mx-auto mb-20"
        />
      </template>
    </router-view>

    <div class="fixed pin-x pin-t flex justify-end px-4 py-6">
      <a
        id="surco-link"
        href="https://www.zeczec.com/projects/surco?r=9bde2c92a6"
        target="_blank"
        rel="noopener"
        class="btn btn--outline btn--outline-on-light rounded-full">
        <svg height="24" viewBox="0 0 495 172">
          <title>嘖嘖</title>
          <path
            id="logo-zeczec"
            d="M422.476,55.64h-27.35a2.18,2.18,0,0,0-2.17,2.17v51.81a2.18,2.18,0,0,0,2.17,2.17h27.34a2.18,2.18,0,0,0,2.17-2.17V57.81A2.18,2.18,0,0,0,422.476,55.64Zm-7.26,48.53a2.18,2.18,0,0,1-2.17,2.17h-8.49a2.18,2.18,0,0,1-2.17-2.17V63.27a2.18,2.18,0,0,1,2.17-2.17h8.49a2.18,2.18,0,0,1,2.17,2.17Zm54.29-48.6a1.47,1.47,0,0,1-1.47-1.47h0V48.51a1.47,1.47,0,0,1,1.47-1.47h21.51a2.18,2.18,0,0,0,2.17-2.17V43.72a2.18,2.18,0,0,0-2.17-2.17h-21.51a1.47,1.47,0,0,1-1.47-1.47h0V30.17a2.18,2.18,0,0,0-2.17-2.17h-5.4a2.181,2.181,0,0,0-2.16,2.17v9.95a1.47,1.47,0,0,1-1.47,1.47h-20.75a2.18,2.18,0,0,0-2.17,2.17v1.11a2.18,2.18,0,0,0,2.17,2.17h20.73a1.47,1.47,0,0,1,1.49,1.45V54.1a1.47,1.47,0,0,1-1.47,1.47h-17.8a2.18,2.18,0,0,0-2.17,2.17v1.13a2.18,2.18,0,0,0,2.17,2.17h17.79a1.469,1.469,0,0,1,1.48,1.46v5.67a1.47,1.47,0,0,1-1.47,1.47h-20.75a2.18,2.18,0,0,0-2.17,2.17v1.13a2.18,2.18,0,0,0,2.17,2.17h54.85a2.179,2.179,0,0,0,2.17-2.17V71.82a2.179,2.179,0,0,0-2.17-2.17h-21.43a1.47,1.47,0,0,1-1.47-1.47V62.52a1.47,1.47,0,0,1,1.47-1.47h19.95a2.18,2.18,0,0,0,2.17-2.17V57.74a2.18,2.18,0,0,0-2.17-2.17Zm24.38,82.14-15.45-11.88h11a2.776,2.776,0,0,0,2.17-1.14l-1-41c0-2.23-1-3.21-2.17-3.21h-50.79a2.18,2.18,0,0,0-2.17,2.17v41a2.18,2.18,0,0,0,2.17,2.17h11L433.2,137.7a2.18,2.18,0,0,0-.4,3l1.87,2.44a2.18,2.18,0,0,0,3,.4l23.09-17.76h5.55l23.09,17.76a2.179,2.179,0,0,0,3-.4l1.87-2.44a2.18,2.18,0,0,0-.38-2.99Zm-48.78-49.54A2.18,2.18,0,0,1,447.3,86h31.57a2.29,2.29,0,0,1,2.184,2.391c0,.057-.007.113-.014.169l.49,15.61-13.8-.64a1,1,0,0,1-1.01-.99,1.08,1.08,0,0,1,.01-.15l1.17-6.59a1.05,1.05,0,0,0-.927-1.16h0l-21.86-1.2Zm0,30V98.93l15.11,1a1.11,1.11,0,0,1,1,1.21l-1.25,6.48a.931.931,0,0,0,.612,1.164.967.967,0,0,0,.168.036l20.92,1,.33,8.73a2.149,2.149,0,0,1-2.17,1.79h-32.52a2.18,2.18,0,0,1-2.2-2.16ZM269.476,55.64h-27.35a2.18,2.18,0,0,0-2.17,2.17v51.81a2.18,2.18,0,0,0,2.17,2.17h27.34a2.18,2.18,0,0,0,2.17-2.17V57.81A2.18,2.18,0,0,0,269.476,55.64Zm-7.26,48.53a2.18,2.18,0,0,1-2.17,2.17h-8.49a2.18,2.18,0,0,1-2.17-2.17V63.27a2.18,2.18,0,0,1,2.17-2.17h8.49a2.18,2.18,0,0,1,2.17,2.17Zm54.29-48.6a1.47,1.47,0,0,1-1.47-1.47h0V48.51a1.47,1.47,0,0,1,1.47-1.47h21.51a2.18,2.18,0,0,0,2.17-2.17V43.72a2.18,2.18,0,0,0-2.17-2.17h-21.51a1.47,1.47,0,0,1-1.47-1.47h0V30.17a2.18,2.18,0,0,0-2.17-2.17h-5.4a2.181,2.181,0,0,0-2.16,2.17v9.95a1.47,1.47,0,0,1-1.47,1.47h-20.75a2.18,2.18,0,0,0-2.17,2.17v1.11a2.18,2.18,0,0,0,2.17,2.17h20.73a1.47,1.47,0,0,1,1.49,1.45V54.1a1.47,1.47,0,0,1-1.47,1.47h-17.8a2.18,2.18,0,0,0-2.17,2.17v1.13a2.18,2.18,0,0,0,2.17,2.17h17.79a1.469,1.469,0,0,1,1.48,1.46v5.67a1.47,1.47,0,0,1-1.47,1.47h-20.75a2.18,2.18,0,0,0-2.17,2.17v1.13a2.18,2.18,0,0,0,2.17,2.17h54.85a2.179,2.179,0,0,0,2.17-2.17V71.82a2.179,2.179,0,0,0-2.17-2.17h-21.43a1.47,1.47,0,0,1-1.47-1.47V62.52a1.47,1.47,0,0,1,1.47-1.47h19.95a2.18,2.18,0,0,0,2.17-2.17V57.74a2.18,2.18,0,0,0-2.17-2.17Zm24.38,82.14-15.45-11.88h11a2.776,2.776,0,0,0,2.17-1.14l-1-41c0-2.23-1-3.21-2.17-3.21h-50.79a2.18,2.18,0,0,0-2.17,2.17v41a2.18,2.18,0,0,0,2.17,2.17h11L280.2,137.7a2.18,2.18,0,0,0-.4,3l1.87,2.44a2.18,2.18,0,0,0,3,.4l23.09-17.76h5.55l23.09,17.76a2.179,2.179,0,0,0,3-.4l1.87-2.44a2.18,2.18,0,0,0-.38-2.99Zm-48.78-49.54A2.18,2.18,0,0,1,294.3,86h31.57a2.29,2.29,0,0,1,2.184,2.391c0,.057-.007.113-.014.169l.49,15.61-13.8-.64a1,1,0,0,1-1.01-.99,1.08,1.08,0,0,1,.01-.15l1.17-6.59a1.05,1.05,0,0,0-.927-1.16h0l-21.86-1.2Zm0,30V98.93l15.11,1a1.11,1.11,0,0,1,1,1.21l-1.25,6.48a.931.931,0,0,0,.612,1.164.967.967,0,0,0,.168.036l20.92,1,.33,8.73a2.149,2.149,0,0,1-2.17,1.79h-32.52a2.18,2.18,0,0,1-2.2-2.16ZM86.136.17A85.83,85.83,0,1,0,171.966,86,85.83,85.83,0,0,0,86.136.17Zm48.17,93.93-2,8.93c-.28,1.47-1,1.92-2.26,1.85L79.7,102.51a2.141,2.141,0,0,1-1.854-2.392,2.177,2.177,0,0,1,.074-.348l2.86-14.84a2.55,2.55,0,0,0-2.29-2.76l-38.61-2.6c-1.26,0-1.95-.82-1.95-2.26l1.44-8.47c.28-1.43,1-1.77,2.29-1.7l52.16,2.89a2.41,2.41,0,0,1,2.14,2.65l-2.65,15.07a2.331,2.331,0,0,0,2.033,2.593,2.275,2.275,0,0,0,.3.017l37.38,1.73C134.136,92.09,134.526,92.76,134.306,94.1Z"></path>
        </svg>
        <span class="ml-2">集資開跑</span>
      </a>
    </div>
  </div>
</template>

<script>
import { ApplianceTypes } from "./constants";

export default {
  data() {
    return {
      brandsGroupByType: {},
      ApplianceTypes,
      isLoading: true
    };
  },

  computed: {
    brands() {
      if (this.$route.name === "ApplianceType" && this.$route.params.typeID) {
        return this.brandsGroupByType[this.$route.params.typeID] || [];
      } else {
        return [];
      }
    }
  },

  watch: {
    $route(route) {
      if (route.name === "ApplianceType" && route.params.typeID) {
        this.$nextTick(() => {
          const activeLink = this.$refs.nav.querySelector(
            ".router-link-exact-active"
          );
          if (activeLink) {
            activeLink.scrollIntoView({ inline: "center" });
          }
        });
      }
    }
  },

  async created() {
    try {
      const res = await fetch(
        "https://sheets.googleapis.com/v4/spreadsheets/1NEFkIkTuxFWPNek5x-SAEbA0Fon8xeer03KL8MBRUWE/values/A2:H?majorDimension=COLUMNS&key=AIzaSyARSfllC1qYEPID5wM-nRTK_m-hiTlibgI"
      );

      const { values } = await res.json();

      this.brandsGroupByType = ApplianceTypes.reduce(
        (brandsGroupByType, type, index) => {
          brandsGroupByType[type.id] = values[index] || [];
          return brandsGroupByType;
        },
        {}
      );
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }
};
</script>

<style>
#logo-zeczec {
  transition: 100ms fill ease-in-out;
}

#surco-link:hover #logo-zeczec {
  fill: white;
}
</style>
